export default "__VITE_ASSET__d12a51c3__"